<template>
  <div class="mb-10">
    <AppOnOffToggle v-model="sumDateRanges">{{ label }}</AppOnOffToggle>
  </div>
</template>

<script>
export default {
  name: 'ReportSumDateRangesToggle',
  props: {
    label: {
      type: String,
      default: 'Sum date ranges',
    },
    numericValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sumDateRanges: {
      get() {
        return this.$store.getters.sumDateRanges;
      },
      set(newValue) {
        if (this.numericValue) {
          newValue = newValue ? '1' : '';
        }

        this.$store.dispatch('updateSearch', { sum_date_ranges: newValue });
      },
    },
  },
};
</script>
